var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.esm = leica.pi.esm || {};

leica.pi.esm.floatingHeaders = (function() {
	"use strict";
	var fh = {};
	
	// Cache the $(window) reference for use during scroll events.
	var $window = $( window );
	
	var stickyNavTop = 0;
	
	// this is for narrow down the call of list based on specific section id
	// initial set to html till it is assigned a specific section/segment
	var $segment = $('html');
	
	var colNav = leica.pi.esm.columnNavigator;
	
	var ensureHeadersArePositionedCorrectly = function(e,$table) {	
		var hp = {};		
		if(!$table){return;} 
		
		var $section = $table.filter(':visible');
		//Return from the method if table is hidden
		if(!$section){
			return;
		}
		var $NavRow = $section.find('.navfloat');
		
		var ScrollTop = $window.scrollTop();
		var SectionTop = $NavRow.attr('origtop');									// Get fixed reference point
		var inlineHeaderRow = $table.find('.tableFloatingHeaderOriginal');
		var floatingHeaderRow = $table.find('.tableFloatingHeader_clone'); 		
		var cssPosition = $NavRow.css('position');

		// Section to check for the bottom top position 
		var lf = $section.find('.ListFooter');
		var tableBottomTop = Infinity;
		if(lf.filter('.Paginator')){
			tableBottomTop = lf.attr('origtop');
		}		
		// collapse the floating header when scrolling, crossed the table 
		if(ScrollTop > tableBottomTop){
			hideFloatingHeader();
		} else if (ScrollTop > SectionTop) {
			// This is technically just a flag to see if we've already applied the style changes; maybe we can make that more obvious?
			if (cssPosition !== 'fixed' || e.type === 'resize') { 					
				// Get the top navigation based on sticky header
				fh.detailsHeader.StickyHeaderNavTop();
				var NavTop = stickyNavTop;
				var HeaderTop = NavTop + $NavRow.height();

				$NavRow.css({
					'position': 'fixed',					
					'top': NavTop,
					'max-width': $table.width(), 									// Prevent the nav bar from overflowing the table when removing from the flow
					'z-index': '100', 												// Prevents the nav bar from disappearing when taken out of the DOM's flow layout
					'background-color': 'white'
				});

				// Position, size, and show the floating row.
				floatingHeaderRow.css({
					'display': '',
					'top': HeaderTop,
					'min-width': 'inherit',
					'max-width': 'inherit',
					'width': $table.find('.divTableWithFloatingHeader').width(),
					'overflow':'hidden',
					'z-index': 999	// Use Z-Index to hide the inline header as it scrolls past the top of the screen
				});

				// Since the floating row is taken out of the document's flow, it has no way of knowing what its cells' width
				// should be, so we copy the width of each cell in the inline header row to give it a hint.
				inlineHeaderRow.find('th').each(function (index) {
					var desiredWidth = ($(this).width());
					floatingHeaderRow.find('th').eq(index).css({
						'min-width': desiredWidth,
						'max-width': desiredWidth,
						'width': desiredWidth
					});
				});
				
			}
		} else if (cssPosition === 'fixed') {
			hideFloatingHeader();
		} else if (ScrollTop < SectionTop){
			// Positioned the column navigation back after ajax call and resize back
			// This will effecitve with lh.sectionPositioned
			if(e.type === 'resize'){
				$NavRow.css({
					'max-width': $table.width(), 									// Prevent the nav bar from overflowing the table when removing from the flow
					'z-index': '100' 												// Prevents the nav bar from disappearing when taken out of the DOM's flow layout
					
				});
			}
		}
		
		// update the floating header top position once resize off or 
		// fresh scroll in resize window to tablet or mobile width 
		if(e.type === 'resize'  || e.type === 'scroll'){
			updateCloneFloatingHeader();
		}
		// Hide bulktask row and floating header row.
		function hideFloatingHeader() {
			$NavRow.css({				
				'position':'',
				'background-color': ''
			});

			// Hide the floating row
			floatingHeaderRow.css({
				'display': 'none'
			});
		}
		//Update the floating header top value & width e.g while resize back
		function updateCloneFloatingHeader() {
			//Recalculate the top position of clone floating header after resize out.
			var HeaderTop = NavTop + $NavRow.height();
			
			//Recalculate FloatingHeader width to match the width of DivWrapper
			floatingHeaderRow.css({	
				'top': HeaderTop,
				'width': $table.find('.divTableWithFloatingHeader').width()
			});			
		}
		// update the floating header and bulktask top value
		hp.updateFloatingHeadersNavTop = function(e){
			// Get the top navigation based on sticky header
			fh.detailsHeader.StickyHeaderNavTop();
			var NavTop = stickyNavTop;
			var HeaderTop = NavTop + $NavRow.height();		
			$NavRow.css({
				'top': NavTop				
			});
			floatingHeaderRow.css({	
				'top': HeaderTop				
			});		
		}		
		return hp;
	}
	
	
	/* ================== Listing Module==================*/
	var listHeader = (function() {
		var lh = {};
		var cloneHeaderAttributes;
		function CloneHeader() {
			$segment.find('table.ListTable').filter(function() {
				return ($(this).parents('div.divTableWithFloatingHeader').length < 1) && ($(this).attr('id') !== 'AnnotationLayerTable');

			}).each(function() {
				var $this = $(this);
				// add this check to add divTableWithFloatingHeader only once under ListTable
				if  ($this.attr('class') === 'ListTable') {
					// Clone the table header, leaving it in place to flow with the page, then allow original to float
					// giving it a "sticky" appearance.
					var inlineHeaderRow = $("tr:first", this);

					// Don't create more floating clones than we need. There's some kind of race condition calling
					// this function more often than needed. TODO: Figure out why...
					if (inlineHeaderRow.hasClass('tableFloatingHeader_clone')) {
						return;
					}

					// Need to set z-index to set the order over positioned div tags
					// This will fix the issue in FF when the floating row is not nested within parent div
					$this.wrap("<div class=\"divTableWithFloatingHeader\" style=\"z-index:1;position:relative\"></div>");

					var floatingHeaderRow = inlineHeaderRow.clone();
					floatingHeaderRow.attr("id", inlineHeaderRow.attr('id') + '_clone');
					floatingHeaderRow.addClass("tableFloatingHeader tableFloatingHeader_clone");

					// Configure the floating header to float. Hide it by default so we don't confuse the users.
					// It needs to be positioned too. We do this in `handleFloatingHeaderOnScroll()` in 12.3.js.
					// TODO: Consider reworking this functionality in a more generic fashion, rather than spreading it across files.
					floatingHeaderRow.css({
						'position': 'fixed',
						'display': 'none'
					});

					inlineHeaderRow.before(floatingHeaderRow);
					inlineHeaderRow.addClass("tableFloatingHeaderOriginal");
					
				}
			});
		};
		function listLoad($table){
			var $body = $('body');
			if(typeof $table === 'undefined' || !$table.length){
				return;
			}
			
			// Let the delay less to visible/ hide floting header on time.
			// Let it throttle to vanish header, once scroll above list header.
			$window.on('scroll resize', window.piDash.throttle(function(e){ensureHeadersArePositionedCorrectly(e,$table)},60));
					
			// Detect page Reloaded. 1 represents page reloaded
			if(window.performance && performance.navigation.type  === 1 ) {
			    var $resHeader = ensureHeadersArePositionedCorrectly({}, $table);
				// If the user scrolls, then refreshes the floating header may not be visible. Let's make sure it is. The 
 				// setTimeout delays the update till the page has painted more fully. It will kinda awkwardly jump in but at
 				// least the user isn't left hanging.
				setTimeout(function() {
					// Update the navtop for both navfloat and floating header after repaint.
					$resHeader.updateFloatingHeadersNavTop();						
 				}, 800);				          
			}
			
			// Area for tab changed e.g. specimen tab open
			$body.on('tabChanged', function(event, data){ 
				// update the navfloat offset when we navigating tab
				fh.detailsHeader.UpdateNavFloatOffset();
			});	
			
		}
		/* ** assign the navfloat and origtop ***/
		lh.NavFloat = function() {
			$segment.find('table.ListHeader').each(function() { 
				var $this = $(this);
				if(typeof $this != 'undefined' && $this.not('.navfloat').length) {
					
					$this.attr("id", $this.attr('id') + '_navfloat');
					$this.addClass('navfloat');
					// Save fixed reference point
					$this.attr('origtop', $this.offset().top);							
				}
			});
			
			fh.detailsHeader.UpdateTableBottomOffset();
		};
		
		// Retain the floating header intact when applying pagination or sort or ajax call 
		lh.retainFloatingHeaderCloneAttr = function($section){
			var $cloneHeaderTrAttr = [];
			var $cloneHeaderThAttr = [];
			var $fixedColumnFirstDiv = [];
			var $cloneHeader = $section.find('.ListTableDiv .tableFloatingHeader');
			
			if($cloneHeader.is(':visible')){				
				// get the properties of clone header element
				$cloneHeaderTrAttr =  $cloneHeader.prop('attributes');		
				
				// get all the th properties of floating header
				$cloneHeader.find('th').each(function(){
					var $this = $(this);
					$cloneHeaderThAttr.push($this.prop('attributes'));
				});
				
				// get the properties of fixed column 
				$fixedColumnFirstDiv = $cloneHeader.find('th.fixed-column div').first().prop('attributes');
				
			}
			
			cloneHeaderAttributes = function($table){
				
					$table.find('.ListTableDiv .ListTable').each(function() {
						var $this = $(this);
						
						// clone header element
						var $inlineHeaderRow = $("tr:first", $this);
						
						// retain attributes for clone header tag 
						assignAttributes($cloneHeaderTrAttr,$inlineHeaderRow);
						
						// retain attributes of all th element of cloning header
						$inlineHeaderRow.find('th').each(function(index){
							assignAttributes($cloneHeaderThAttr[index],$(this));
						});
						
						// retain fixed column left position when column navigation not in beginning
						assignAttributes($fixedColumnFirstDiv,$inlineHeaderRow.find('th.fixed-column div').first());
						
					});
				
			};
		}
		// Iterate the properties and assign to a specific element
		function assignAttributes($attr, $element){
			if($attr && $attr.length>0){
				$.each($attr, function(key, atts){ 
					$element.attr(atts.name, atts.value);							 
				});
			}
		}
		
		lh.sectionPositioned = function($section){
			var sectionOffsetTop = $section.offset().top;
			// Substract a static number time being to jump to the specific location 
			$window.scrollTop(sectionOffsetTop-70);
		}
		
		lh.run = function(name) {
			if($('#'+name).length > 0){				
				$segment = $('#'+name);
			}
			CloneHeader();
			leica.pi.esm.floatingFooter.CloneFooter($segment);
			
			lh.NavFloat();
			$segment.find('.ListTableDiv').parent().not('.GrandChildTable,.columnScrolling-loaded').each(function(){					
				var $table = $(this);
				
				leica.pi.esm.floatingFooter.run($table);
				
				listLoad($table);
				colNav.columnScrolling($table);
				colNav.syncHeader($table);
				
			});
		}	
		
		lh.refresh = function(name){
			if($('#'+name).length > 0){				
				$segment = $('#'+name);
			}
			CloneHeader();
			leica.pi.esm.floatingFooter.CloneFooter($segment);
			
			lh.NavFloat();
			
			$segment.find('.ListTableDiv').parent().not('.GrandChildTable,.columnScrolling-loaded').each(function(){		
				var $table = $(this);
				
				leica.pi.esm.floatingFooter.run($table);
				
				listLoad($table);
				colNav.columnScrolling($table);
				colNav.syncHeader($table);
				
				if(typeof cloneHeaderAttributes === 'function'){
					cloneHeaderAttributes($table);
				}				
			});
		}
		
		return lh;
		
	}());
	fh.listHeader = listHeader;
	
	
	
	/* ============== Details module =================*/
	var detailsHeader = (function(){
		var stickyHeader = '';
		var dh = {};
		
		function StickyHeader(){
			var $body = $('body');
			// Create/add the sticky header div
			stickyHeader = $('<div class="sticky-header"></div>');
			if($body.find('div.sticky-header').length === 0){
				$body.append(stickyHeader);
			}			
			var fixedSectionHeaders = window.piDash.throttle(function fixedSectionHeadersFunction(event){
			    // The jQuery specific `:visible` pseudo selector is ridiculously inefficient; don't use it to do full-DOM
			    // searches. More info here (https://api.jquery.com/visible-selector/) under "additional notes".
			    var $sections = $('.section-dark, .section-light').filter(':visible');
			    var $section;
			    var $h3;
			    for (var i = $sections.length - 1; i >= 0; i--) {
			      $section = $($sections[i]);
			      $h3 = $section.find('>h3');
			      var _top = $section.offset().top;
				  // use $(window).scrollTop() rather than window.scrollTop, because 
				  // window.scrollTop is incorrect in IE 11. 
			      if ($(window).scrollTop() > _top){
			        if ($section.data('sticky-header') === true){
			          return;
			        }
			        $section.data('sticky-header', true);
			        stickyHeader.data('original-elem', $h3);
			        stickyHeader.html($h3.clone());
			        $sections.splice(i, 1);
			        $sections.data('sticky-header', false);
			        return;
			      }
			    }
			    $sections.data('sticky-header', false);
			    stickyHeader.html('');
			  });
			$window.on('scroll resize', fixedSectionHeaders);
			
		}
		
		// Update the navfloat offset when we have toggle any block
		dh.UpdateNavFloatOffset = function() {
			$('table.ListHeader').each(function() { 
				var $this = $(this);
				// update the origtop for navfloat tag
				// in case one column is part of floating header then do not consider for origtop update
				if(typeof $this !== 'undefined' && $this.hasClass('navfloat') && $this.css('position') !== 'fixed') {
					// Update fixed reference point 
					$this.attr('origtop', $this.offset().top);	
				}
			});
			dh.UpdateTableBottomOffset();
		};
		// Update the ListFooter which has Paginator class to vanish the clone floating header 
		dh.UpdateTableBottomOffset = function() {
			// Default assigning origtop to infinity not 0 to make sure it is not floating from beginning
			var origTop = Infinity;
			$('table.ListFooter').each(function() { 
				var $this = $(this);
				if(typeof $this != 'undefined' && $this.find('div.Paginator').length > 0) {
					// Update the same origtop for both expanding and collapsing floating header when table is empty
					if($this.is(':hidden')){
						origTop = $this.parent().find('table.navfloat').attr('origtop');
					} else {
						// Save fixed reference point table bottom position. 
						// Substract some value to collapse the floating header bit earlier
						origTop = $this.offset().top-160;	
					}
					$this.attr('origtop',origTop);
					
				}
			});
		}
		// Get the navigation top from the sticky floating header if present
		dh.StickyHeaderNavTop = function() {
			var $body = $('body');
			var stickyHeight = 0;
			if($body.find('div.sticky-header').length){
				stickyHeight = $body.find('div.sticky-header').height();
				if(stickyHeight){
					stickyNavTop = stickyHeight;
				}
			}
		}
		dh.run = function() {
			StickyHeader();
		}
		
		return dh;
		
	}());
	fh.detailsHeader = detailsHeader;	
	
	return fh;
}());


